import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=b3d88834&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=b3d88834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d88834",
  null
  
)

export default component.exports